import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Box, Heading, Image } from '@wix/design-system';
import { useIsMobile } from '@wix/core-domain-search';
import { Base44Tool } from './Base44Tool';
import Base44Tool1 from '../../assets/images/base44tool1.png';
import Base44Tool2 from '../../assets/images/base44tool2.svg';
import s from '../common.scss';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const Base44MoreTools = () => {
  const isMobile = useIsMobile();
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    gap: isMobile ? 'SP4' : '26px',
    paddingTop: isMobile ? '0' : 'SP10'
  }, /*#__PURE__*/React.createElement(Box, {
    padding: isMobile ? '0' : '16px 0 12px',
    align: "center"
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "large",
    className: s.sectionTitle
  }, t('domains_search_gate.base44.gate.more_tools.title'))), getBase44Tools(t).map(tool => /*#__PURE__*/React.createElement(Base44Tool, _extends({
    key: tool.title
  }, tool, {
    isMobile: isMobile
  }))));
};
const getBase44Tools = t => [{
  title: t('domains_search_gate.base44.gate.more_tools.privacy.title'),
  description: t('domains_search_gate.base44.gate.more_tools.privacy.description'),
  background: 'linear-gradient(180deg, #F4F4F4 21.5%, #D3F0FA 75%, #7CBFD5 88.5%)',
  illustration: /*#__PURE__*/React.createElement(Image, {
    src: Base44Tool1,
    transparent: true,
    fit: "contain",
    width: "495px",
    height: "262px"
  })
}, {
  title: t('domains_search_gate.base44.gate.more_tools.ssl.title'),
  description: t('domains_search_gate.base44.gate.more_tools.ssl.description'),
  background: 'linear-gradient(0deg, #FF5500 0%, #FFC494 20%, #EDEAE4 85%)',
  illustration: /*#__PURE__*/React.createElement(Base44Tool2, null)
}];
//# sourceMappingURL=Base44MoreTools.js.map